import Avatar from "react-avatar";
import TrophyIcon from "./TrophyIcon";

export default function ReferralPosListItem({ name, img, count, position, designation }) {
  return (
    <div className="ReferralPosListItem">
      <div className="ReferralPosListItem-elem-1">
        {position > 3 ? <span>{position}</span> : <TrophyIcon position={position} />}
      </div>
      <div className="ReferralPosListItem-elem-2">
        <Avatar round={true} name={name} size="40" src={img} textSizeRatio={3} />
        <div className="ReferralPosListItem-elem-2-elem-2">
          <div>{name}</div>
          <div>{designation ? designation : `${count} referrals`} </div>
        </div>
      </div>
      {designation ? <span className="ReferralPosListItem-elem-3">{count}</span> : null}
    </div>
  );
}
